import React from "react";
import { useGetPublishedBlogsQuery } from "../../Redux/getApi";
import { NavLink } from "react-router-dom";

const Blog = () => {
  const { data, error, isLoading, isFetching } = useGetPublishedBlogsQuery();
  return (
    <div className="flex bg-white flex-col  lg:gap-10 md:gap-6 gap-4 xl:py-20 lg:py-14 sm:py-10 py-6  xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%] ">
      <div className=" flex flex-col items-center gap-3">
        <span className="bg-[#00643b] py-1 px-4 rounded-full text-white">
          Blogs
        </span>
        {/* <h1 className="lg:text-[2.5rem] text-[2rem] font-bold ">Latest News</h1> */}
        <p className="text-center md:text-[1.3rem] text-[1rem] text-[#0000004A]">
          Stay updated with the latest developments and initiatives from
          Rawalpindi <br className=" sm:block hidden" /> Development Authority
        </p>
      </div>

      {isFetching || isLoading ? (
        <BlogCardLoader items={8} />
      ) : (
        data &&
        (data?.blogs?.length === 0 ? (
          <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#000000]">
            No Blog Found
          </div>
        ) : (
          <div className=" grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-8 self-stretch">
            {data?.blogs?.map((blog, i) => (
              <NavLink
                to={`/blog/${blog?._id}`}
                key={i}
                className={`p-4 relative flex flex-col group cursor-pointer gap-2 rounded-2xl shadow hover:bg-[#00643b] hover:text-white bg-[#F6F6F6] text-black
             `}
              >
                <span
                  className={`absolute bg-[#00643b] text-white text-[.9rem]  py-1 px-4 top-6 left-6 rounded-lg`}
                >
                  Blog
                </span>
                <img
                  src={blog?.coverImage?.imageUrl}
                  className="rounded-2xl"
                  alt=""
                />
                <h1 className="text-[1.2rem] font-medium">{blog.title}</h1>
                {/* <p
                  className={`group-hover:text-[#FFFFFFA3] text-[#000000A3] text-[.9rem]`}
                >
                  RDA Enforcement Squad Demolishes, Removes Encroachments and
                  Seals 65 Properties on Gangal Service Road.
                </p> */}
              </NavLink>
            ))}
          </div>
        ))
      )}

      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message || error?.data?.error}
        </p>
      )}
    </div>
  );
};

export const BlogCardLoader = ({ items }) => {
  return (
    <div
      className="w-full
    grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-8"
    >
      {[...Array(items)].map((_, i) => (
        <div
          key={i}
          className="animate-pulse bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm"
        >
          {/* Image Skeleton */}
          <div className="w-full h-44 bg-gray-200" />

          <div className="p-4 space-y-3">
            {/* Tag */}
            <div className="w-14 h-5 bg-gray-200 rounded-full" />

            {/* Title */}
            <div className="w-3/4 h-4 bg-gray-200 rounded" />

            {/* Description */}
            <div className="space-y-2">
              <div className="w-full h-3 bg-gray-200 rounded" />
              <div className="w-5/6 h-3 bg-gray-200 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Blog;
